import { render } from "./form-register.vue?vue&type=template&id=4347c4ce&scoped=true"
import script from "./form-register.vue?vue&type=script&lang=js"
export * from "./form-register.vue?vue&type=script&lang=js"

import "./form-register.vue?vue&type=style&index=0&id=4347c4ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4347c4ce"]])

export default __exports__